const ONE_WEEK = 604800000;

export const BASE_URL = process.env.NODE_ENV === 'development' ? '' : '/atlaskit/registry';
export const STORY_BASE_URL = 'https://aui-cdn.atlassian.com/atlaskit/stories';

export const TABS = [
  {
    title: 'All components',
    filter: () => true,
  },
  {
    title: 'React',
    filter: component => component.platform === 'React',
    selected: true,
  },
  {
    title: 'AtlasKit',
    filter: component => component.name.indexOf('ak-') === 0,
  },
  {
    title: 'Editor',
    filter: component => component.name.indexOf('ak-editor-') === 0,
  },
  {
    title: 'Utils',
    filter: component => component.name.indexOf('akutil-') === 0,
  },
  {
    title: 'Fabric',
    filter: component => component.name.indexOf('pf-') === 0,
  },
  {
    title: 'Linting',
    filter: component => component.name.indexOf('eslint-') === 0,
  },
  {
    title: 'Updated this week',
    filter: component => component.publishTimestamp > Date.now() - ONE_WEEK,
    sort: (a, b) => b.publishTimestamp - a.publishTimestamp,
  },
];



// WEBPACK FOOTER //
// ./src/config.js